import { ArrowRight } from "lucide-react";
import { cn } from "../../lib/utils";
import { generateWhatsAppUrl } from "../../lib/whatsapp";

/**
 * Primary WhatsApp CTA button. Variants: 'primary' (green pill) | 'ghost' (outline)
 */
export default function WhatsAppButton({
  label = "Get a Free Quote via WhatsApp",
  service,
  message,
  variant = "primary",
  className,
  size = "md",
  testId = "whatsapp-cta",
  ...rest
}) {
  const href = generateWhatsAppUrl({ service, message });
  const sizes = {
    sm: "px-4 py-2.5 text-sm",
    md: "px-5 py-3.5 text-sm",
    lg: "px-7 py-4 text-base",
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={cn(
        "group inline-flex items-center gap-2.5 rounded-full font-semibold transition-colors duration-300",
        sizes[size],
        variant === "primary"
          ? "bg-emerald text-ink hover:bg-emerald-light"
          : "border border-white/25 text-white hover:border-emerald hover:text-emerald bg-transparent",
        className
      )}
      {...rest}
    >
      <WhatsIcon className="w-4 h-4" />
      {label}
      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
    </a>
  );
}

function WhatsIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden>
      <path d="M20.5 3.5A11 11 0 0 0 3.7 17.2L2 22l4.9-1.6a11 11 0 0 0 5.2 1.3h.1a11 11 0 0 0 8.3-18.2Zm-8.4 17a9 9 0 0 1-4.6-1.3l-.3-.2-2.9.9.9-2.8-.2-.3a9 9 0 1 1 7.1 3.7Zm5-6.7c-.3-.1-1.8-.9-2-1s-.5-.1-.7.2-.8 1-.9 1.1-.3.2-.6.1a7.3 7.3 0 0 1-2.2-1.4 8 8 0 0 1-1.5-1.9c-.2-.3 0-.4.1-.6l.4-.4.2-.4v-.4l-1-2.3c-.2-.6-.4-.5-.6-.5h-.6c-.2 0-.5.1-.8.4a3.6 3.6 0 0 0-1.1 2.7c0 1.6 1.1 3.1 1.3 3.3.2.3 2.3 3.4 5.5 4.8.8.3 1.4.5 1.8.6.8.3 1.5.2 2 .1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4l-.5-.3Z" />
    </svg>
  );
}
